import React,{useState,useEffect,useRef} from 'react';
import ModalProducts from './modal-products';
import ModalPayment from './modal-payments';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSearch, 
    faUserAlt, 
    faList, 
    faPlusCircle,
    faReceipt,
    faLocation, 
    faArrowTurnDown,
    faTerminal,
    faSignOut,
    faBarcode,
    faListUl,
    faBars,
    faMoneyBill,
    faClock,
    faRefresh,
    faPlus,
    faInfoCircle,
    faRightFromBracket,
    faPrint,
    faEdit,
    faNoteSticky,
    faComment,
    faTrash,
    faCartFlatbed,
    faUnlock,
    faLock,
    faCutlery,
    faUtensils,
    faMoneyBillTransfer,
    faListCheck,
    faFileInvoice
} from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import ModalCustomer from './modal-customer';
import SideBar from '../Layouts/sideBar';
import Swal from 'sweetalert2';
import {Spinner,Row,Col,DropdownButton,Dropdown,Button} from 'react-bootstrap';
import { nFormat } from '../Vendor/common';
import { useNavigate } from 'react-router-dom';
import ModalBb from './modal-bb';
import ModalAccess from './modal-access';
import SelectGroup from './atoms/SelectGroup';
import ModalMultiPrice from './modal.multi.price';
import ModalArea from './organisms/ModalArea';
import ModalAccount from './modal-account';
import ModalFittings from './organisms/ModalFittings';
import ModalComanda from './organisms/ModalComanda';
import ModalPendingAccount from './organisms/ModalPendingAccount';
// Create our number formatter.
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',  
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
const defaultUserInfo = {
    location: '',
    terminal: '',
    posDiscount: 'f',
    posLimitDiscount: 0
}
const defaultPermissions = {
    pin: false,
    rAccount: false,
    printPermission: false
}
const defaultCurrentProductSelected = {
    product_id: 0,
    condition_id: 0,
    unit_id: 0,
    extraSelected: []
}

const Pos = () => {
    const [modalProducts,setModalProducts] = useState(false),
        [modalCustomer,setModalCustomer] = useState(false),
        [modalPayments,setModelPayments] = useState(false),
        [modalProductsParam,setModalProductsParam] = useState({}),
        [modalCustomersParam,setCustomersParam] = useState({}),
        [modalBdParams,setBdParams] = useState({}),
        [modalBb,setModalBb] = useState(false),
        [modalBbRemoveNote,setModalBbRemoveNote] = useState(false),
        [criteria,setCriteria] = useState(''),
        [barcode,setBarcode] = useState(''),
        [products,setProducts] = useState([]),
        [customerOptions,setCustomerOptions] = useState([]),
        [cusOptionSelected,setCusOptionSelected] = useState({
            value: 0, 
            label: 'Seleccionar un cliente',
            document_type: '',
            document_type_id: 0
        }),
        [subCategories,setSubCategories] = useState([]),
        [productList,setProductList] = useState([]),
        [statusSubCategories,] = useState(true),
        [shoppingCartPos,setShoppingCartPos] = useState([]),
        [openSideBar,setOpenSideBar] = useState(false),
        [accountList,setAccountList] = useState([]),
        [accountHeadId,setAccountHeadId] = useState(0),
        [loadingProduct,setLoadingProduct] = useState(false),
        [disabledCustomerOption,setDisabledCustomerOption] = useState(false),
        [ncfInfo,setNcfInfo] = useState([]),
        [defaultCurrency,setDefaultCurrency] = useState(0),
        [defaultCurrencyLabel,setDefaultCurrencyLabel] = useState(''),
        [currencyConversionAmount,setCurrencyConversionAmount] = useState(0),
        [currenciesList,setCurrenciesList] = useState([]),
        [userPersonalName,setUserPersonalName] = useState(''),
        [allowToCreateProduct,setAllowToCreateProduct] = useState(false),
        [userInfo,setUserInfo] = useState(defaultUserInfo),
        [checkBb,setCheckBb] = useState(false),
        [searchingBy,setSearchingBy] = useState(2),
        [limitData,setLimitData] = useState(0),
        [thereAreProducts,setThereAreProducts] = useState(false),
        [subCategorySelected,setSubCategorySelected] = useState(0),
        [instantProducts,setInstantProducts] = useState([]),
        [accountLoading,setAccountLoading] = useState(false),
        [accessShow,setAccessShow] = useState(false),
        [accessAllow,setAccessAllow] = useState(true),//se va a poner true por defecto a menos que el cliente decida que tiene que esta false
        navigate = useNavigate(),
        barcodeInputRef = useRef(),
        searchingInput = useRef(),
        pageScrolling = useRef(),
        [tableAccount,setTableAccount] = useState(0),
        [tableAccountDescription,setTableAccountDescription] = useState(""),
        [accountTables,setAccountTables] = useState([]),
        [selectCurrencyInputDisabled,setSelectCurrencyInputDisabled] = useState(false),
        [billingUser,setBillingUser] = useState(null),
        [posPermissions,setPosPermissions] = useState(defaultPermissions),
        [showMultiPrice,setShowMultiPrice] = useState(false),
        [productSelectedToMulti,setProductSelectedToMulti] = useState({}),
        [pricingList,setPricingList] = useState([]),
        [priceForMulti,setPriceForMulti] = useState(0),
        [outDecimals, setOutDecimals] = useState(0),
        [autoMarkLawPercent, setAutoMarkLawPercent] = useState(false),
        [paymentConditions,setPaymentConditions] = useState([]),
        [guessChangeCustomer,setGuessChangeCustomer] = useState(false),
        //forUpdate
        [customerIdInput, setCustomerIdInput] = useState(0),
        [customerNameInput, setCustomerNameInput] = useState(null),
        [customerPhoneInput, setCustomerPhoneInput] = useState(null),
        [customerEmailInput, setCustomerEmailInput] = useState(null),
        [customerDocumentInput, setCustomerDocumentInput] = useState(null),
        [customerDocumentTypeInput, setCustomerDocumentTypeInput] = useState(null),
        [customerBpDateInput, setCustomerBpDateInput] = useState(null),
        [customerPaymentMethod,setCustomerPaymentMethod] = useState(5),
        [visible,setVisible] = useState(false),
        [identifierPreSelection,setIdentifierPreSelection] = useState(0),
        [execFe,setExecFe] = useState(false),
        [useFe,setUseFe] = useState('f'),
        [openAccountRegistered,setOpenAccountRegistered] = useState(null),
        [itemAccounts,setItemAccounts] = useState([]),
        [showModalItemAccount,setShowModalItemAccount] = useState(false),
        [openToRemoveItem,setOpenToRemoveItem] = useState(false);
    let searchingByCriteria = searchingBy == 1 ? "active" : "",
        searchingByBarCode = searchingBy == 2 ? "active" : "";
    const [newShoppingCart, setNewShoppingCart] = useState([])

    const [showFittingsModal, setShowFittingsModal] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [selectFittingData, setSelectFittingData] = useState([]);
    const [modalFittingsData,setModalFittingsData] = useState([]);
    const [currentProductSelected,setCurrentProductSelected] = useState(defaultCurrentProductSelected)
    const [currentFittingData, setCurrentFittingData] = useState(null)

    const [showComanda,setShowComanda] = useState(false)
    const [comandas,setComandas] = useState([])

    const [fnComment, setFnComment] = useState('')

    const [newItemAdded, setNewItemAdded] = useState(false)
    
    const [printCommands,setPrintCommands] = useState('f')

    const [itemWasDeleted,setItemWasDeleted] = useState(false)

    const [accountComandaSelected,setAccountComandaSelected] = useState(null)

    const [isMobile, setIsMobile] = useState(false)

    const [pendingAccountList, setPendingAccountList] = useState([])

    const [pendingModalAccount, setPendingModalAccount] = useState(false)

    const [exentoTaxes, setExentoTaxes] = useState(null)

    // Función para manejar cuando se guarda la selección
    const handleSave = (data) => {
        let localChanges = [...selectFittingData]
        let isInArr = false
        if ( localChanges )
        {
            for ( let i = 0; i < localChanges.length; i++ )
            {
                const obj = localChanges[i];
                if ( 
                    Number(obj.product_id) === Number(currentProductSelected.product_id) &&
                    Number(obj.unit_id) === Number(currentProductSelected.unit_id) &&
                    Number(obj.condition_id) === Number(currentProductSelected.condition_id)
                )
                {
                    isInArr = true
                    localChanges[i].extraSelected = [...data]
                    break;
                }
            }
        }

        if ( !isInArr )
            localChanges.push({
                ...currentProductSelected,
                extraSelected: [...data]
            })

        const objectLocalChange = localChanges[localChanges.length-1];
        setCurrentFittingData(objectLocalChange)
        setSelectFittingData(localChanges);
        
        //Agregar comentario al artículo
        addNoteToItem(currentProductSelected.product_id, currentProductSelected.condition_id, currentProductSelected.unit_id, true, fnComment)
    };
    const consultGeneralInfo = async(defineCurrency)=>{
        defineCurrency = defineCurrency !== undefined ? defineCurrency : 0;
        setLoadingProduct(true);
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/pos/info',
                {
                    token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                    defineCurrency: defineCurrency
                }),
                data = await resource.data;
                if(data.sessionOut){
                    // eslint-disable-next-line no-undef
                    location.href=process.env.REACT_APP_PATH_APP;
                    return;
                }

                setOutDecimals(parseInt(data.outDecimals));
                setAutoMarkLawPercent(data.autoMarkLawPercent==='t')
                setProducts(data.products);
                setSubCategories(data.subCategories);
                setCustomerOptions(data.customers);
                setAccountList(data.accounts);
                setLoadingProduct(false);
                setNcfInfo(data.ncf);
                setDefaultCurrency(data.defaultCurrency);
                setDefaultCurrencyLabel(data.defaultCurrencyLabel);
                setCurrenciesList(data.currenciesList);
                setUserPersonalName(data.user_personal_name);
                // setBusinessBox(data.businessBox);
                setAllowToCreateProduct(data.createProduct);
                setUserInfo({
                    ...userInfo,
                    location: data.userLocation,
                    terminal: data.terminalLabel,
                    posDiscount: data.pos_discount,
                    posLimitDiscount: data.pos_limit_discount
                });
                setCheckBb(data.businessBox);
                setBdParams({
                    currencies: data.currencies,
                    terminalId: data.terminalID,
                    terminalLabel: data.terminalLabel,
                    saleCurrencyDefault: data.defaultCurrency
                });
                setIdentifierPreSelection(data.identifierPreSelection!==undefined&&data.identifierPreSelection!==null&&data.identifierPreSelection?data.identifierPreSelection:0);
                setThereAreProducts(data.thereAreMore);
                setLimitData(data.limitProduct);

                setAccountTables(data.accountTables);

                setPrintCommands(data.print_commands);

                /**barcode input focus */
                if(searchingBy==2)
                    barcodeInputRef.current.focus();

                // if(defineCurrency>0){
                //     setDefaultCurrency(defineCurrency);
                // }

                setCurrencyConversionAmount(data.currencyConversion);
                /**SET PERMISSIONS */
                setPosPermissions({
                    pin: data.pinPermission,
                    rAccount: data.removeAccount,
                    printPermission: data.printPermission
                });                
                setPaymentConditions(data.paymentConditions);
                setExecFe(data.auto_fe==='t')
                setUseFe(data.use_fe)

                setExentoTaxes(data.exentoTaxes)
        } catch(error){
            setLoadingProduct(false);
            Swal.fire({
                icon:'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    useEffect(()=>{
        consultGeneralInfo()
        //Mobile....
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    },[]);
    useEffect(()=>{
        let rows = [],
            columns = [];        
        if(products!==undefined&&products!==null&&products.length)
        {
            // eslint-disable-next-line react/prop-types
            products.map((element,index)=>{
                let pathFile = '/image_not_found.png';
                if(element.path_file){
                    // eslint-disable-next-line no-undef
                    pathFile = process.env.REACT_APP_PATH_FILE + /*'files/items/' +*/ element.path_file;
                }
                let colorInv = element.item_qty_inv > 0 ? '#198754' : '#dc3545';
                //element.multiPrice
                columns.push(
                    <div key={'column-'+index} className='col-md-2'>                        
                        <div className="card cursor align-items-center" /*style={{margin: '10px'}}*/ id={element.product_id} multi={element.multiPrice?1:0} hasprice={parseFloat(element.total_price)>0?1:0} onClick={addToShopping}>
                            {
                                element.use_inventory === 't' ?
                                    <div className="ribbon ribbon-success"><FontAwesomeIcon icon={faCartFlatbed} /></div>
                                : null
                            }                            
                            <img src={pathFile} className="card-img-top" alt="IMAGE NOT FOUND" /*id={element.product_id} onClick={addToShopping}*/ style={{width: '100%',height: 'auto'}} />
                            <div className="card-body">
                                <p className="card-text" style={{fontSize: '10px',fontWeight: 'bold',textAlign: 'center',marginBottom: '0'}}>{element.product_code}</p>
                                <p className="card-text" style={{fontSize: '10px',fontWeight: 'bold',textAlign: 'center',marginBottom: '0',textTransform: 'capitalize'}}>{element.product_des}</p>
                                <p className="card-text" style={{fontSize: '8px',fontWeight: 'bold',textAlign: 'center',marginBottom: '0',textTransform: 'capitalize'}}>{element.sub_category_des}</p>
                                <p 
                                    className={`card-text ${element.discountByPrice!==undefined&&element.discountByPrice!==null&&element.discountByPrice>0?'lineThrough':''}`} 
                                    style={{fontSize: '11px',fontWeight: 'bold',textAlign: 'center',color: '#0d6efd',marginBottom: '0'}}
                                >
                                    {
                                        element.discountByPrice!==undefined&&element.discountByPrice!==null&&element.discountByPrice>0?
                                            `$${nFormat(parseFloat(element.total_price).toFixed(outDecimals))}`
                                        :
                                            parseFloat(element.total_price)>0? `$${nFormat(parseFloat(element.total_price_with_taxes).toFixed(outDecimals))}`:''
                                    }
                                </p>
                                {
                                    element.discountByPrice!==undefined&&element.discountByPrice!==null&&element.discountByPrice>0&&parseFloat(element.total_price)>0?
                                        <>
                                            <p className='card-text' style={{fontSize: '11px',fontWeight: 'bold',textAlign: 'center',color: '#f00',marginBottom: '0'}}>{'$'+nFormat(parseFloat(element.discountByPrice).toFixed(outDecimals))}</p>
                                            <p className='card-text' style={{fontSize: '11px',fontWeight: 'bold',textAlign: 'center',color: 'rgb(8 115 56)',marginBottom: '0'}}>
                                                {
                                                    parseFloat(element.total_price)>0? '$' + nFormat(parseFloat(( parseFloat(element.total_price)-parseFloat(element.discountByPrice) )).toFixed(outDecimals)) : ''
                                                }
                                            </p>
                                        </>
                                    :null
                                }
                                {/* <p className='card-text' style={{fontSize: '14px',fontWeight: 'bold',textAlign: 'center',color: colorInv,marginBottom: '0'}}>Maneja inventario {element.use_inventory_label}</p> */}
                                <p className='card-text' style={{fontSize: '11px',fontWeight: 'bold',textAlign: 'center',color: colorInv}}>Inventario:{element.item_qty_inv}</p>                            
                                {/* <a href='#' id={element.product_id} onClick={editProduct}>Editar producto</a>                             */}
                            </div>
                        </div>
                    </div> 
                );            
                if(index>0&&((index+1)%6)===0){
                    rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                    columns = [];
                } else {
                    if(products[(index+1)]===undefined){
                        rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                        columns = [];
                    }
                }
            });
        }
        /** Si no hay productos registrados */
        if(rows.length<1){
            rows.push(
                <div className='row' key={"product-not-found"}>
                    <div className='col-12'>
                        <div className="card">
                            <div className="card-body">
                                <h3>Informaciones</h3>
                                {/* eslint-disable-next-line react/no-unescaped-entities*/}
                                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'blue'}} /> No tienes productos registrados, para poder realizar tus ventas será necesario que agregues aunque sea un producto. Encuentra el boton 'Productos' y procede con el registro de los mismos.<br /><br />
                                {/* eslint-disable-next-line react/no-unescaped-entities*/}
                                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'blue'}} />Puedes recibir el código de 'Acceso' para poder realizar algunas de las acciones dentro de la aplicación, tal como poder remover artículos desde la lista temporal de compra.<br /><br />
                                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'blue'}} />Si deseas facturar con valor fiscal, solo debes contactarnos por cualquiera de nuestras vías y con gusto te atenderemos.<br /><br />
                                Si tienes alguna duda ó te gustaria adquirir un plan mas avanzado, puedes contactarnos vía <a href='https://www.oshencore.com/#/contact/us' target="_blank" rel="noreferrer">www.oshencore.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        setProductList(rows);
    },[products]);
    useEffect(()=>{
        if(searchingBy==2){
            barcodeInputRef.current.focus();
        }
    },[searchingBy]);
    useEffect(()=>{
        if(instantProducts.length)
            instantAddToShopping();
    },[instantProducts]);
    useEffect(()=>{
        if(shoppingCartPos.length>0){
            setSelectCurrencyInputDisabled(true);
        } else {
            setSelectCurrencyInputDisabled(false);
        }
        let newRecords = [...shoppingCartPos];
        const nsc = sameProductIsThere(newRecords);
        setNewShoppingCart(nsc)
    },[shoppingCartPos]);
    useEffect(()=>{
        if(cusOptionSelected!==undefined&&cusOptionSelected!==null&&parseInt(cusOptionSelected.value)>0){            
            //changeButtonForUpdate
            setGuessChangeCustomer(true);
        } else {
            setGuessChangeCustomer(false);
        }
    },[cusOptionSelected])
    // eslint-disable-next-line no-unused-vars
    const openArticleModel = async () => {
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/product/info',{token: localStorage.getItem('OSHEN-LOC-STR-TK')}),
                data = await resource.data;
            setModalProductsParam(data);
            setModalProducts(true);
        } catch(error){
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const openCustomerModal = async() => {
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/customer/info'),
                data = await resource.data;
                setCustomersParam(data);
                setCustomerNameInput(null);
                setModalCustomer(true);
        } catch(error){
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }        
    }
    const openCustomerModalForUpdate = async() => {
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/customer/info/for/update',{id: parseInt(cusOptionSelected.value)}),
                data = await resource.data;
                setCustomerIdInput(parseInt(cusOptionSelected.value));
                setCustomerPhoneInput(data.customer.bp_phone_1);
                setCustomerEmailInput(data.customer.bp_email);
                setCustomerDocumentInput(data.customer.bp_document);
                setCustomerDocumentTypeInput(data.customer.bp_document_type);
                setCustomerBpDateInput(data.customer.bd_date);
                //el nombre debe ser el ultimo para que tome el useEffect
                setCustomerNameInput(data.customer.customer_name);
                setCustomerPaymentMethod(parseInt(data.customer.payment_method_id));
                setCustomersParam(data);
                setModalCustomer(true);
        } catch(error){
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }   
    }
    const searchProducts = async() => {
        setLoadingProduct(true);
        setSubCategorySelected(0);
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/products',{
                criteria: criteria,
                token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                defineCurrencyId: defaultCurrency
            }),
                data = await resource.data;
                if(data.sessionOut){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'La sesión ha expirado, será redireccionado'
                    }).then(()=>{
                        // eslint-disable-next-line no-undef
                        location.href = process.env.REACT_APP_PATH_APP;
                    });
                    return false;
                }
                setProducts(data.products);
                setThereAreProducts(data.thereAreMore);
                setLimitData(data.limitProduct);
                setLoadingProduct(false);
                /**clear input*/
                searchingInput.current.value = '';
                setCriteria('');
        } catch(error){
            setLoadingProduct(false);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const searchProductsByBarcode = async() => {
        // setLoadingProduct(true);
        setSubCategorySelected(0);
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/products',{
                criteria: barcode,
                token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                barcoding: true,
                defineCurrencyId: defaultCurrency
            }),
                data = await resource.data;

                if(data.sessionOut){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'La sesión ha expirado, será redireccionado'
                    }).then(()=>{
                        // eslint-disable-next-line no-undef
                        location.href = process.env.REACT_APP_PATH_APP;
                    });
                    return false;
                }
                if(data.products.length){
                    setInstantProducts(data.products);
                    // instantAddToShopping(data.products[0].product_id);
                    barcodeInputRef.current.value = '';
                    barcodeInputRef.current.focus();
                }
                // setLoadingProduct(false);
        } catch(error){
            // setLoadingProduct(false);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const searchBySubCategory = async(e) => {
        setLoadingProduct(true);
        setSubCategorySelected(e);
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/products',{
                criteria: criteria,
                sc: e,
                token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                defineCurrencyId: defaultCurrency
            }),
                data = await resource.data;
                if(data.sessionOut){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'La sesión ha expirado, será redireccionado'
                    }).then(()=>{
                        // eslint-disable-next-line no-undef
                        location.href = process.env.REACT_APP_PATH_APP;
                    });
                    return false;
                }
                setProducts(data.products);
                setThereAreProducts(data.thereAreMore);
                setLimitData(data.limitProduct);
                setLoadingProduct(false);
        } catch(error){
            setLoadingProduct(false);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const getProductInfo = (productId) => {
        for(let i=0;i<products.length;i++){
            if(parseInt(products[i].product_id) === parseInt(productId)){
                return products[i];
            }
        }
        return null;
    }
    const getProductInfoByInstant = () => {
        return instantProducts[0];
    }
    /**Shop methods */
    const addToShopping = (e) => {
        const pId = e.currentTarget.getAttribute('id'),
            multi = e.currentTarget.getAttribute('multi'),            
            pObj = getProductInfo(pId);        

        const hasPrice = e.currentTarget.getAttribute('hasprice');
        if ( hasPrice == 0 && parseInt(multi)!=1) {
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: 'Este producto no tiene precio registrado'
            });
            return
        }

        if(parseInt(multi)==1){
            handleMulti(pObj);
            return;
        }

        let arr = [];
        pObj.qty = 1;
        pObj.amount = pObj.qty * pObj.total_price;
        pObj.total_amount_tax = pObj.qty * pObj.taxes_amount;
        pObj.total_discount = parseFloat(pObj.qty) * parseFloat(pObj.discountByPrice);
        pObj.total_amount = ( parseFloat( pObj.amount ) + parseFloat( pObj.total_amount_tax ) ) - parseFloat( pObj.total_discount );
        pObj.showingUp = true;
        pObj.showQty = 0;
        arr.push({...pObj});//Se cambio para clonar el objeto ya que con anterioridad estaba haciendo todo por referencia...
        setNewItemAdded(true)
        setShoppingCartPos(prevSCP => ([...prevSCP, ...arr]));
    }
    useEffect(()=>{
        if ( newItemAdded === true && shoppingCartPos !== undefined && shoppingCartPos !== null && shoppingCartPos.length )
        {
            const scp = shoppingCartPos[shoppingCartPos.length-1]
            //Verificar si el ultimo articulo agregado tiene adicionales...
            if ( scp.tableInformation )
            {
                //buscar el articulo que se visualiza por el ultimo...
                for ( let counterLine = 0; counterLine < shoppingCartPos.length; counterLine++ )
                {
                    const objeto = shoppingCartPos[counterLine]
                    if ( 
                        Number(objeto.product_id) === Number(scp.product_id) &&
                        Number(objeto.unit_id) === Number(scp.unit_id) &&
                        Number(objeto.condition_id) === Number(scp.condition_id) &&
                        objeto.showingUp === true
                    )
                    {
                        addFitting(objeto)
                        setNewItemAdded(false)
                        return
                    }
                }
            }
        }
    },[shoppingCartPos])
    const instantAddToShopping = () => {
        let arr = [];
        const pObj = getProductInfoByInstant();
        if(pObj!=null&&pObj!=undefined)
        {
            if(pObj.multiprice==1){
                handleMulti(pObj);
                return;
            }

            pObj.qty = 1;
            pObj.amount = pObj.qty * pObj.total_price;
            pObj.total_amount_tax = pObj.qty * pObj.taxes_amount;
            pObj.total_discount = parseFloat(pObj.qty) * parseFloat(pObj.discountByPrice);
            pObj.total_amount = ( parseFloat( pObj.amount ) + parseFloat( pObj.total_amount_tax ) ) - parseFloat( pObj.total_discount );
            pObj.showingUp = true;
            pObj.showQty = 0;

            arr.push(pObj);
            setNewItemAdded(true)
            setShoppingCartPos(prevSCP => ([...prevSCP, ...arr]));
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: 'El producto no pudo ser encontrado, favor intentar luego ó contacte al administrador'
            });
        }
    }    
    const removeItemFromShoppingCart = (element) => {
        if(posPermissions.pin&&!openToRemoveItem) {
            Swal.fire({
                title: 'Ingresa tu PIN para eliminar',
                input: 'password',
                inputAttributes: {
                    maxlength: 4
                },
                showCancelButton: true,
                confirmButtonText: 'Validar'
            }).then(async(result)=>{
                if(result.isConfirmed){
                    // eslint-disable-next-line no-undef
                    const resource = await axios.post(process.env.REACT_APP_PATH_API + 'check/access/pin/for/remove/item',{
                        token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                        pin: result.value
                    }),
                    data = await resource.data;
                    if(!data.status){
                        Swal.fire({
                            icon: 'warning',
                            title: 'Advertencia',
                            text: data.message
                        });
                        return;
                    }
                    if ( !data.accessToRemove )
                    {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Advertencia',
                            text: 'Permiso denegado'
                        });
                        return;
                    }
                    setOpenToRemoveItem(data.accessToRemove)
                }
            });
           return 
        }
        let shopping = [...shoppingCartPos]
        let dataProductId = element.currentTarget.getAttribute('dataproductid')
        let dataConditionId = element.currentTarget.getAttribute('dataconditionid')
        let dataUnitId = element.currentTarget.getAttribute('dataunitid')

        if ( shopping )
        {
            let lastIndexToRemove = null
            for ( let i = 0; i < shopping.length; i++ ) 
            {
                const obj = shopping[i]
                if (
                    !obj.showingUp &&
                    Number(obj.product_id) === Number(dataProductId) &&
                    Number(obj.unit_id) === Number(dataUnitId) &&
                    Number(obj.condition_id) === Number(dataConditionId)
                ) 
                {
                    lastIndexToRemove = i
                }
            }

            if ( lastIndexToRemove === null )
            {
                for ( let i = 0; i < shopping.length; i++ ) 
                {
                    const obj = shopping[i]
                    if (
                        obj.showingUp &&
                        Number(obj.product_id) === Number(dataProductId) &&
                        Number(obj.unit_id) === Number(dataUnitId) &&
                        Number(obj.condition_id) === Number(dataConditionId)
                    ) 
                    {
                        lastIndexToRemove = i
                    }
                }
            }

            shopping.splice(lastIndexToRemove, 1)
            setShoppingCartPos(shopping);

            //Para saber si hubieron items eliminados
            setItemWasDeleted(true)
        }
        return
    }    
    const handleSideBarShow = () => {
        if(openSideBar)
        {
            setOpenSideBar(false)
        }
        else 
        {
            setOpenSideBar(true)
        }
    }
    const createAccount = async () => {
        if(shoppingCartPos.length<1){
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: "Debes seleccionar al menos un producto"
            });
            return;
        }
        if(cusOptionSelected===null){
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: "Debes seleccionar al menos un cliente"
            });
            return;
        }
        if(parseInt(cusOptionSelected.value)<1){
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: "Debes seleccionar al menos un cliente"
            });
            return;
        }

        setAccountLoading(true);
        try{
            // eslint-disable-next-line no-undef
            const resource = axios.post(process.env.REACT_APP_PATH_API + 'save/account',{
                token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                data: shoppingCartPos,
                customer: cusOptionSelected.value,
                accountHeadId: accountHeadId,
                tableAccount: tableAccount,
                defineCurrencyId: defaultCurrency,
                selectFittingData: selectFittingData,
                itemWasDeleted: itemWasDeleted
            }),
                resourceData = await resource,
                data = resourceData.data;
            if(data.status)
            {
                setAccountList(data.accounts);
                setShoppingCartPos([]);
                setCusOptionSelected(null);
                handleSideBarShow(true);
                setAccountHeadId(0);
                setTableAccount(0);
                setDisabledCustomerOption(false);
                setOpenAccountRegistered(null);

                //Abrir impresion de comanda
                if ( printCommands === 't' )
                {
                    setComandas(data.comandas);
                    setShowComanda(true);
                }

                //Para saber si hubieron items eliminados
                setItemWasDeleted(false)
            } 
            else 
            {
                Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: data.msg
                });
            }
            setAccountLoading(false);
        } catch(e){
            setAccountLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const openNewAccount = () => {
        setShoppingCartPos([]);
        const inputCustomerOption = {
            value: 0, 
            label: 'Seleccionar un cliente',
            document_type: '',
            document_type_id: 0
        };
        setCusOptionSelected(inputCustomerOption);
        setAccountHeadId(0);
        setDisabledCustomerOption(false);
        setTableAccount(0);
        setOpenAccountRegistered(null);

        setSelectFittingData([])
        setCurrentProductSelected(defaultCurrentProductSelected)
        setCurrentFittingData(null)
        setItemWasDeleted(false)
    }
    const openBusinessBox = () => {
        // eslint-disable-next-line no-undef
        // window.open(process.env.REACT_APP_PATH_APP + 'business/box?app=83',"","width=1024,height=758");
        navigate('/businessbox');
    }
    const openTurn = () => {
        setModalBb(true)
    }    
    const giveMeMoreProducts = async() => {
        let giveMeMore = limitData + 10;
        setLoadingProduct(true);
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API+'get/products',{
                token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                limitData: giveMeMore,
                sc: subCategorySelected,
                defineCurrencyId: defaultCurrency
            }),
                data = resource.data;
                if(data.sessionOut){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'La sesión ha expirado, será redireccionado'
                    }).then(()=>{
                        // eslint-disable-next-line no-undef
                        location.href = process.env.REACT_APP_PATH_APP;
                    });
                    return false;
                }
                setProducts(data.products);
                setThereAreProducts(data.thereAreMore);
                setLimitData(data.limitProduct);
                setLoadingProduct(false);
                /*---Scrolling---*/
                pageScrolling.current?.scrollIntoView({behavior: 'smooth'});
        } catch (error) {
            setLoadingProduct(false);
            Swal.fire({
                icon:'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }        
    }
    const refreshProducts = async() => {
        setLoadingProduct(true);
        setSubCategorySelected(0);
        setCriteria('');
        try{
            //'get/products'
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'refresh/product/pos',{
                token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                defineCurrencyId: defaultCurrency
            }),
                data = await resource.data;
                if(data.sessionOut){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'La sesión ha expirado, será redireccionado'
                    }).then(()=>{
                        // eslint-disable-next-line no-undef
                        location.href = process.env.REACT_APP_PATH_APP;
                    });
                    return false;
                }
                setProducts(data.products);
                setThereAreProducts(data.thereAreMore);
                setLimitData(data.limitProduct);
                setLoadingProduct(false);
        } catch(error){
            setLoadingProduct(false);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const changeDefaultCurrency = async(input) => {
        const value = input.target.value;
        try{
            setPriceForMulti( value );
            consultGeneralInfo( value );
        } catch(error){
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }        
    }    
    const addItemToShopping = (element) => {
        let shopping = [...shoppingCartPos]
        let dataProductId = element.currentTarget.getAttribute('dataproductid')
        let dataConditionId = element.currentTarget.getAttribute('dataconditionid')
        let dataUnitId = element.currentTarget.getAttribute('dataunitid')

        if ( shopping )
        {
            for ( let i = 0; i < shopping.length; i++ ) 
            {
                const obj = shopping[i]
                if (
                    Number(obj.product_id) === Number(dataProductId) &&
                    Number(obj.unit_id) === Number(dataUnitId) &&
                    Number(obj.condition_id) === Number(dataConditionId)
                ) 
                {
                    const newElement = {...shopping[i]}
                    newElement.showQty = 0
                    newElement.showingUp = false
                    delete newElement.pos_bill_detail_id
                    shopping.push(newElement)
                    setShoppingCartPos(shopping)
                    return true
                }
            }
        }
        return false
    }
    const addNoteToItem = (product_id, condition_id, unit_id, showSwal, comment) => {
        let arr = [...shoppingCartPos]
        let objProductIndex = null
        for ( let i = 0; i < arr.length; i++ )
        {
            const obj = arr[i]
            if ( 
                Number(obj.product_id) === Number(product_id) &&
                Number(obj.condition_id) === Number(condition_id) &&
                Number(obj.unit_id) === Number(unit_id) &&
                obj.showingUp
            )
            {
                objProductIndex = i
                break;
            }
        }

        if ( showSwal === undefined || showSwal === null )
        {
            if ( objProductIndex === undefined || objProductIndex === null ) {
                Swal.fire({
                    icon: "warning",
                    title: "Advertencia",
                    text: "No se ha encontrado artículo asociado"
                })
                return
            }
            Swal.fire({
                title: `¿Alguna nota para ${arr[objProductIndex].product_des} que te gustaría agregar?`,
                text: arr[objProductIndex].item_note?`Mensaje Registrado: ${arr[objProductIndex].item_note}`:'',
                input: 'text',
                showCancelButton: true,
                confirmButtonText: 'Agregar Nota',
            }).then((result)=>{
                if(result.isConfirmed)
                {                
                    arr[objProductIndex].item_note = result.value
                    setShoppingCartPos(arr);
                }
            });
        }
        else
        {
            arr[objProductIndex].item_note = comment
            setShoppingCartPos(arr);
        }
    }
    const searchBillingUser = () => {
        if(shoppingCartPos===undefined||shoppingCartPos===null||shoppingCartPos.length<1){
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: 'No existe ningun producto seleccionado, favor seleccioone al menos un producto'
            });
            return;
        }
        if(!posPermissions.pin){
            setModelPayments(true);
            return;
        }
        Swal.fire({
            title: 'Ingresa tu PIN para facturar',
            input: 'password',
            inputAttributes: {
                maxlength: 4
            },
            showCancelButton: true,
            confirmButtonText: 'Validar'
        }).then(async(result)=>{
            if(result.isConfirmed){
                // eslint-disable-next-line no-undef
                const resource = await axios.post(process.env.REACT_APP_PATH_API + 'check/access/pin',{
                    token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                    pin: result.value
                }),
                data = await resource.data;
                if(!data.status){
                    Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: data.message
                    });
                    return;
                }
                setBillingUser(data.usr);
                setModelPayments(true);
            }
        });
    }
    const printTurnTicket = async() => {
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'turn/info',{
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = await resource.data;
            // eslint-disable-next-line no-undef
            window.open(process.env.REACT_APP_PATH_APP+data.path,"","width=1024,height=950");
        } catch(error) {
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const handleMulti = async(product) => {
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/pricing/by/product', {productId: product.product_id, defaultCurrency: priceForMulti}),
                data = await resource.data;
            setShowMultiPrice(true);
            setProductSelectedToMulti(product);
            setPricingList(data);
        }catch(error){
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }        
    }
    const applyDiscount = (input) => {

        if ( userInfo.posDiscount == 'f' ) {
            return;
        }

        const idx = input.target.getAttribute('id');
        let sp = { ...shoppingCartPos[idx] },
             arr = [...shoppingCartPos];
        Swal.fire({
            title: `Aplicar porciento(%) de descuento a -> ${sp.product_des}`,
            input: 'number',
            inputAttributes: {
                step: 'any', // Permite valores decimales como 99.99
            },
            showCancelButton: true,
            confirmButtonText: 'Aplicar',
        }).then((result)=>{
            if(result.isConfirmed)
            {

                if ( parseFloat(userInfo.posLimitDiscount) > 0 && parseFloat(result.value) > parseFloat(userInfo.posLimitDiscount) ) {
                    Swal.fire({
                        title: 'Advertencia',
                        text: `No puedes aplicar un descuento mayor a $${userInfo.posLimitDiscount}`
                    })
                    return;
                }

                if ( parseFloat(result.value) > 100 ) {
                    Swal.fire({
                        title: 'Advertencia',
                        text: `Excediste el limite de por ciento permitido, favor ingresar una cantidad menor a 100%`
                    })
                    return;
                }

                for ( let counter = 0; counter < arr.length; counter++ )
                {
                    const spo = arr[counter]

                    if ( 
                        Number(sp.product_id) === Number(spo.product_id) &&
                        Number(sp.condition_id) === Number(spo.condition_id) &&
                        Number(sp.unit_id) === Number(spo.unit_id)
                    )
                    {
                        console.log('spo>>',spo)
                        const percent = Number((parseFloat(result.value)/100));
                        const value = Number((parseFloat((Number(spo.amount) * percent)).toFixed(2)));

                        const subTotalAfeterDiscount =  Number(spo.amount) - value 

                        let totalTaxAmountByProduct = 0
                        if ( spo.taxes !== undefined && spo.taxes !== null && spo.taxes.length )
                        {
                            spo.taxes.map(({tax_percent,tax_amount,sum_percent_amount}, taxIndex)=>{
                                let taxAmountCalc = parseFloat(( subTotalAfeterDiscount * (Number(tax_percent)/100) ).toFixed(2))
                                if ( sum_percent_amount == 't' ) {
                                    taxAmountCalc += Number(tax_amount)
                                }
                                arr[counter].taxes[taxIndex].calculated_taxes = taxAmountCalc
                                totalTaxAmountByProduct += taxAmountCalc
                            })
                        }

                        arr[counter].taxes_amount = totalTaxAmountByProduct
                        arr[counter].total_amount_tax = totalTaxAmountByProduct
                        arr[counter].discountByPrice += value;
                        arr[counter].total_discount += value;
                        arr[counter].total_amount = (subTotalAfeterDiscount + totalTaxAmountByProduct);
                        
                    }
                    
                }

                console.log('arr>>',arr)

                // let totalItemQty = 0
                // arr.map(({product_id, condition_id, unit_id, qty})=> {
                //     if ( 
                //         Number(product_id) === Number(sp.product_id) &&
                //         Number(condition_id) === Number(sp.condition_id) &&
                //         Number(unit_id) === Number(sp.unit_id)
                //     )
                //     {
                //         totalItemQty += parseFloat(qty)
                //     }
                // })
                // console.log('totalItemQty>>', totalItemQty)
                // const percent = Number((parseFloat(result.value)/100));
                // const value = (parseFloat((Number(sp.total_price) * percent)).toFixed(2));
                // // const value = parseFloat(result.value);

                // // console.log('Discount->', value)
                // // console.log('sp', sp)
                // // console.log('arr->',arr)

                // sp.discountByPrice += value;
                // sp.total_discount += value;
                // sp.total_amount -= value;
                // if( parseFloat(sp.total_amount) < 0 )
                // {
                //     Swal.fire({
                //         icon: 'warning',
                //         title: 'Advertencia',
                //         text: 'El descuento no puede ser mayor al monto del producto'
                //     });
                //     return;
                // }
                // arr[idx] = sp;
                setShoppingCartPos(arr);
            }
        });
    }    
    const sameProductIsThere = (arrShoppingCard) => {
        let productConsulted = []
        for ( let i = 0; i < arrShoppingCard.length; i++ ) 
        {
            let addToList = true;
            const obj = arrShoppingCard[i]
            if ( productConsulted )
                for ( let c = 0; c < productConsulted.length; c++ )
                {
                    const obj2 = productConsulted[c]
                    if ( 
                        Number(obj.product_id) === obj2.product_id &&
                        Number(obj.unit_id) === obj2.unit_id &&
                        Number(obj.condition_id) === obj2.condition_id
                    )
                    {
                        addToList = false;                        
                        arrShoppingCard[i].showingUp = false
                        arrShoppingCard[i].showQty = Number(arrShoppingCard[i].showQty) + 1
                    }    
                }

            if ( addToList )
            {
                productConsulted.push({
                    product_id: Number(obj.product_id),
                    unit_id: Number(obj.unit_id),
                    condition_id: Number(obj.condition_id)
                })
            }
        }
        //Count...
        for ( let i = 0; i < arrShoppingCard.length; i++ ) 
        {
            const obj = arrShoppingCard[i]
            if ( obj.showingUp ) 
            {
                let productConsultCounter = 0
                for ( let c = 0; c < arrShoppingCard.length; c++ )
                {
                    const obj2 = arrShoppingCard[c]
                    if ( 
                        Number(obj.product_id) === Number(obj2.product_id) &&
                        Number(obj.unit_id) === Number(obj2.unit_id) &&
                        Number(obj.condition_id) === Number(obj2.condition_id)
                    )
                    {                            
                        productConsultCounter = productConsultCounter + 1;
                    }
                }
                arrShoppingCard[i].showQty = productConsultCounter
            }
        }

        return arrShoppingCard
    }
    const selectCurrentAdditional = (element) => {
        if ( selectFittingData )
        {
            let isInArrayFitting = false
            for ( let fCounter = 0; fCounter < selectFittingData.length; fCounter++ )
            {
                if ( 
                    Number(element.product_id) === Number(selectFittingData[fCounter].product_id) &&
                    Number(element.condition_id) === Number(selectFittingData[fCounter].condition_id) &&
                    Number(element.unit_id) === Number(selectFittingData[fCounter].unit_id)
                )
                {
                    isInArrayFitting = true
                    setCurrentFittingData(selectFittingData[fCounter])
                }
            }
            if ( !isInArrayFitting )
            {
                setCurrentFittingData(null)
            }
        }
        else
        {
            setCurrentFittingData(null)
        }
    }
    const addFitting = (element) => {
        selectCurrentAdditional(element)
        setCurrentProductSelected({
            ...currentProductSelected,
            product_id: Number(element.product_id),
            condition_id: Number(element.condition_id),
            unit_id: Number(element.unit_id)
        })
        setModalFittingsData(element.tableInformation)
        setShowFittingsModal(true)
        setFnComment(element.item_note)
    }
    const consultPendingAccounts = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_PATH_API}consult/pending/accounts/${localStorage.getItem('OSHEN-LOC-STR-TK')}`),
                data = res.data
            setPendingAccountList(data)
            setPendingModalAccount(true)
        } catch ( err ) {
            console.log('Error consulting pendings account', err)
        }
    }
    let scAmount = 0,
        scSubTotal = 0,
        scTaxes = 0,
        scDiscount = 0;    
    return (
        <>
        <SideBar 
            show={openSideBar} 
            handleShow={handleSideBarShow} 
            accounts={accountList}
            accountTables={accountTables}
            accountSetter={setAccountList} 
            formatter={formatter} 
            handleShoppingCart={setShoppingCartPos} 
            handleCusRef={setCusOptionSelected}
            handleAccountHeadId={setAccountHeadId}
            accountHeadId={accountHeadId}
            setDisabledCustomerOption={setDisabledCustomerOption}
            setTableAccount={setTableAccount}
            setTableAccountDescription={setTableAccountDescription}
            setDefaultCurrency={setDefaultCurrency}
            defaultCurrency={defaultCurrency}
            setSelectCurrencyInputDisabled={setSelectCurrencyInputDisabled}
            removePermission={posPermissions.rAccount}
            outDecimals={outDecimals} 
            openAccountRegistered={openAccountRegistered}
            setCurrentFittingData={setCurrentFittingData}
            setSelectFittingData={setSelectFittingData}
            setCurrentProductSelected={setCurrentProductSelected}
            setShowComanda={setShowComanda}
            setComandas={setComandas}
            accountComandaSelected={accountComandaSelected}
            setAccountComandaSelected={setAccountComandaSelected}
        />
        <div className='container-fluid content-top'>
            <div className='row'>
                <div className={`col-${isMobile?'12':'8'}`} style={{paddingRight: '0',paddingLeft: 0}}>
                    <nav className="navbar navbar-light bg-white headers-styling nav-bar">
                        <div className="container-fluid">
                            <button 
                                type="button" 
                                className="btn btn-primary position-relative btn-md" 
                                style={{color: "#fff"}}
                                onClick={handleSideBarShow}
                            >
                                <FontAwesomeIcon icon={faReceipt} />
                                {
                                    accountList!==undefined&&accountList!==null&&accountList.length?
                                        <span 
                                            className="position-absolute top-0 start-100 translate-middle bg-danger border border-light rounded-circle badge-accounts"
                                        >
                                            {accountList.length}<span className="visually-hidden">-</span>
                                        </span>
                                    : null
                                }                                
                            </button>
                            <form className={`d-flex`}>
                                {
                                    accessAllow&&posPermissions.pin?
                                        <button 
                                            className='btn btn-link btn-sm' 
                                            type='button' 
                                            title={openToRemoveItem?`Acceso concedido`:`Acceso negado`}
                                            style={{marginLeft: 10, color: '#797676', fontSize: 16}} 
                                            onClick={()=>{
                                                if ( openToRemoveItem )
                                                {
                                                    setOpenToRemoveItem(false)
                                                }
                                            }}>
                                                {
                                                    openToRemoveItem?
                                                        <FontAwesomeIcon icon={faUnlock} className='text-success' />
                                                    : <FontAwesomeIcon icon={faLock} className='text-danger' />
                                                }                                    
                                        </button>
                                    :null
                                }                                
                                <button 
                                    className='btn btn-link btn-sm btn-custom-link' 
                                    type='button' 
                                    title='Lista de factura'
                                    style={{marginLeft: 10}} 
                                    onClick={()=>window.open(process.env.REACT_APP_PATH_APP + 'invoice-management-consult?app=49')}>
                                    <FontAwesomeIcon icon={faList} /> <span style={{fontSize: 12}}>Lista de factura</span>
                                </button>                                
                                <button 
                                    className='btn btn-link btn-sm btn-custom-link' 
                                    type='button' 
                                    title='Turnos'
                                    style={{marginLeft: 10}} 
                                    onClick={()=>navigate('/bb-history')}>
                                    <FontAwesomeIcon icon={faClock} /> <span style={{fontSize: 12}}>Turnos</span>
                                </button>
                                <button 
                                    className='btn btn-link btn-sm btn-custom-link' 
                                    type='button' 
                                    title='Refrescar listado de producto'
                                    style={{marginLeft: 10}}
                                    onClick={refreshProducts}>
                                    <FontAwesomeIcon icon={faRefresh} /> <span style={{fontSize: 12}}>Refrescar listado de producto</span>
                                </button>
                                {
                                    checkBb ?                                         
                                        <button 
                                            className="btn btn-link btn-sm btn-custom-link" 
                                            type="button" 
                                            title='Cuadre'
                                            style={{marginLeft: 10}} 
                                            onClick={openBusinessBox}>
                                            <FontAwesomeIcon icon={faMoneyBill} /> <span style={{fontSize: 12}}>Cuadre de caja</span>
                                        </button>
                                    : null
                                }                                
                                {
                                    // allowToCreateProduct ? 
                                    //     <button 
                                    //         className="btn btn-link btn-sm btn-custom-link" 
                                    //         type="button" 
                                    //         title='Productos'
                                    //         style={{marginLeft: 10}} 
                                    //         onClick={()=>window.open(process.env.REACT_APP_PATH_APP + 'product?app=10')/*openArticleModel*/}>
                                    //         <FontAwesomeIcon icon={faBars} /> <span style={{fontSize: 12}}>Nuevo Producto</span>
                                    //     </button>
                                    // : null
                                }
                                <button 
                                    className="btn btn-link btn-sm btn-custom-link" 
                                    type="button" 
                                    title='Consulta de cuentas pendientes'
                                    style={{marginLeft: 10}} 
                                    onClick={consultPendingAccounts}>
                                    <FontAwesomeIcon icon={faMoneyBillTransfer} /> <span style={{fontSize: 12}}>Cuentas pendientes</span>
                                </button>
                            </form>
                        </div>
                    </nav>
                </div>
                <div className={`col-${isMobile?'12':'4'}`} style={{paddingLeft: '0'}}>
                    <nav className="navbar navbar-light bg-white headers-styling nav-side nav-bar" style={{height: '100%'}}>
                        <div className="container-fluid button-select-option" style={{paddingLeft: '0px'}}>
                            <DropdownButton
                                style={{marginLeft: 12}} 
                                type="button" 
                                variant='primary' 
                                size="sm" 
                                title={[<FontAwesomeIcon icon={faUserAlt} key='icon-name' />,' ',userPersonalName[0]]}>
                                <Dropdown.ItemText>Informaciones de turno</Dropdown.ItemText>
                                <Dropdown.ItemText><FontAwesomeIcon icon={faUserAlt} /> {userPersonalName}</Dropdown.ItemText>
                                <Dropdown.ItemText><FontAwesomeIcon icon={faLocation} /> {userInfo.location}</Dropdown.ItemText>
                                <Dropdown.ItemText><FontAwesomeIcon icon={faTerminal} /> {userInfo.terminal}</Dropdown.ItemText>
                                <hr />
                                {
                                    allowToCreateProduct ? 
                                        <Dropdown.Item 
                                            as="button" 
                                            type='button' 
                                            onClick={()=>window.open(process.env.REACT_APP_PATH_APP + 'product?app=10')}>
                                                <FontAwesomeIcon icon={faBars} key='icon-name' /> Nuevo Producto
                                        </Dropdown.Item>                                        
                                    : null
                                }
                                {
                                    !checkBb?
                                        <Dropdown.Item as="button" type='button' onClick={openTurn}><FontAwesomeIcon icon={faArrowTurnDown} key='icon-name' /> Abrir Turno</Dropdown.Item>
                                    :   
                                    <>
                                        <Dropdown.Item as="button" type='button' onClick={printTurnTicket}><FontAwesomeIcon icon={faPrint} key='print-turn-ticket' /> Ver Ticket de Turno</Dropdown.Item>
                                        <Dropdown.Item as="button" type='button' onClick={()=>{setModalBbRemoveNote(true);openTurn();}}><FontAwesomeIcon icon={faMoneyBillTransfer} key='print-turn-ticket' /> Agregar monto a caja</Dropdown.Item>
                                    </>
                                }                                
                                {/* eslint-disable-next-line no-undef */}
                                <Dropdown.Item as="button" type='button' onClick={()=>location.href=process.env.REACT_APP_PATH_APP}><FontAwesomeIcon icon={faRightFromBracket} /> Salir de la aplicación</Dropdown.Item>
                                { /* eslint-disable-next-line no-undef */ }
                                <Dropdown.Item as="button" type='button' onClick={()=>location.href=process.env.REACT_APP_PATH_APP+"log-out"}><FontAwesomeIcon icon={faSignOut} /> Cerrar Sesión</Dropdown.Item>
                            </DropdownButton>
                            <span style={{fontSize: '14px',fontWeight: 'bold', marginLeft: '5%'}}>
                                Factura:
                            </span>
                            <SelectGroup 
                                onChange={changeDefaultCurrency} 
                                value={defaultCurrency} 
                                className="col-2" 
                                inputName="posInvoiceCurrency" 
                                id="posInvoiceCurrency"
                                options={( currenciesList!==undefined && currenciesList!==null && Object.keys(currenciesList).length>0)?currenciesList:[]}
                                inputClassName='form-control-sm'
                                generalClassName='mb-0'
                                defaultOptionValue="==="
                                disabled={selectCurrencyInputDisabled}
                            />
                            <span style={{fontSize: '14px',fontWeight: 'bold'}}>
                                Tasa: {currencyConversionAmount!=1?currencyConversionAmount:'N/A'}
                            </span>
                            {/* <a className="navbar-brand" style={{fontSize: '14px',fontWeight: 'bold'}}>Factura en {defaultCurrencyLabel}</a> */}
                        </div>
                    </nav>
                </div>
            </div>
            <div className='row'>
                <div className={`col-${isMobile?'12':'8'}`} style={{paddingRight: 0,paddingLeft: 1}}>
                    <div className="input-group mb-1 input-select-content" style={{marginTop: '0.5rem'}}>                        
                        {/* <input type="text" className="form-control" aria-label="Amount (to the nearest dollar)" /> */}
                        {
                            !guessChangeCustomer?
                                <button className="btn btn-success" type="button" onClick={openCustomerModal}><FontAwesomeIcon icon={faPlusCircle} /> Nuevo Cliente</button>
                            :
                                <button className="btn btn-primary" type="button" onClick={openCustomerModalForUpdate}><FontAwesomeIcon icon={faEdit} /> Actualizar Cliente</button>
                        }                        
                        <Select 
                            options={customerOptions} 
                            className="form-control" 
                            value={cusOptionSelected}
                            defaultValue={cusOptionSelected} 
                            onChange={(input)=>{
                                setCusOptionSelected(input)
                            }}
                            isDisabled={disabledCustomerOption}
                                />                        
                        {/* <span className="input-group-text">Nuevo cliente</span> */}
                    </div>
                </div>
                <div className={`col-${isMobile?'12':'4'}`}>
                    <div className="input-group mb-1" style={{marginTop: '0.5rem'}}>                        
                        <Button 
                            variant="warning" 
                            style={{width: '100%'}}
                            onClick={()=>{
                                setVisible(true)
                            }}
                        >
                            <FontAwesomeIcon icon={faUtensils} /> {tableAccount>0?`Area seleccionada: ${tableAccountDescription}`:`¿El cliente utilizará alguna area?`}
                        </Button>
                    </div>
                </div>                
            </div>            
            <div className='row' style={{marginTop: '2vh'}}>
                <div className={`col-${isMobile?'12':'8'} ei-height bg-grey`}>
                    <div className='container-fluid'>

                    <div className='row mb-3 top-padding-8p'>
                        <div className='col-12' style={{paddingRight: 0,paddingLeft: 1}}>
                            <div className='row'>
                                <div className='col-12' style={{paddingBottom: '5px'}}>
                                    <div className="input-group">
                                        <span onClick={()=>setSearchingBy(1)} className={`input-group-text btn btn-primary ${searchingByCriteria}`}>
                                            <FontAwesomeIcon icon={faListUl} />
                                        </span>
                                        <span onClick={()=>setSearchingBy(2)} className={`input-group-text btn btn-primary ${searchingByBarCode}`}>
                                            <FontAwesomeIcon icon={faBarcode} />
                                        </span>
                                        {
                                            searchingBy==1?
                                                <>
                                                    <input 
                                                        type="text"
                                                        ref={searchingInput}
                                                        className="form-control" 
                                                        placeholder="Buscar producto por criterio" 
                                                        onKeyDown={(e)=>{
                                                            if(e.key==='Enter'){
                                                                searchProducts();
                                                            }
                                                        }}
                                                        onChange={(input)=>{                                        
                                                            setCriteria(input.target.value)
                                                        }} />
                                                    <button className="btn btn-success" type="button" onClick={searchProducts}><FontAwesomeIcon icon={faSearch} /></button>
                                                    {/* <button className={`btn btn-info ${viewerOfCategories}`} type="button" onClick={()=>{setStatusSubCategories(statusSubCategories ? false : true);}}><FontAwesomeIcon icon={faList} /></button> */}
                                                </>
                                            :
                                                <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Escanear código de barra"
                                                ref={barcodeInputRef}
                                                onKeyDown={(e)=>{
                                                    if(e.key==='Enter'){
                                                        searchProductsByBarcode();
                                                    }
                                                }}
                                                onChange={(input)=>{                                        
                                                    setBarcode(input.target.value)
                                                }} />
                                        }                                
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        
                        {
                            statusSubCategories ?
                                <div className='row'>
                                    <div className='col-12 container-carusel-custom mb-3'>
                                        <div className="carousel-custom">
                                            <div className="item-custom" onClick={()=>searchBySubCategory(0)}>
                                                <div className="card">
                                                    <img src="/img_not_found.png" className="card-img-top" alt="SUB-CATEGORY-IMG" />
                                                </div>
                                                <h1>Productos</h1>
                                            </div>
                                            {
                                                subCategories.map((element,index)=>{
                                                    // eslint-disable-next-line no-undef
                                                    const photo = element.path_file ? process.env.REACT_APP_PATH_APP + element.path_file : '/img_not_found.png';
                                                    return (
                                                        <div key={index} className="item-custom" onClick={()=>searchBySubCategory(element.sub_category_id)}>
                                                            <div className="card">
                                                                <img src={photo} className="card-img-top" alt="SUB-CATEGORY-IMG" />
                                                            </div>
                                                            <h1>{element.sub_category_des}</h1>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            : null
                        }                    
                        {
                            !loadingProduct ?
                                productList
                            :<Row>
                                <Col md={{ span: 3, offset: 6 }} style={{marginTop: '25%'}}>
                                    <Spinner animation="border" variant="primary" />
                                </Col>
                            </Row>
                        }
                        {
                            thereAreProducts?
                                <div className='d-flex justify-content-center' style={{marginTop: '1rem',marginBottom: '1rem'}}>
                                    <Button variant="primary" onClick={giveMeMoreProducts}>Cargar mas productos...</Button>
                                </div>
                            :null
                        }
                    </div>
                    <div ref={pageScrolling} />
                </div>
                <div className={`col-${isMobile?'12':'4'} ei-height bg-white content-border`} style={{paddingRight: 0}}>
                    <div className='terf-height'>
                        <table className="table">
                            <tbody>                                    
                            {
                                newShoppingCart!==undefined&&newShoppingCart!==null&&newShoppingCart.length?        
                                    newShoppingCart.map((element,index)=>{
                                        return (
                                            <tr key={index} className={`${!element.showingUp?"hide-content":""}`}>
                                                <th scope="row" style={{width: '5%'}} className='top-padding-5p'>{(index+1)}</th>
                                                <td style={{width: '45%'}} className='top-padding-5p'>
                                                    <span style={{fontSize: '9px',fontWeight: 'bold'}}>
                                                        { `${element.product_code} ${element.product_des} ${element.condition_des}` }
                                                    </span><br />
                                                    <span style={{fontSize: '8px',marginRight: '5px',color: 'rgb(25 135 84)',fontWeight: 'bold'}}>Prec.${nFormat(parseFloat(element.total_price).toFixed(outDecimals))}</span>
                                                    <span style={{fontSize: '8px',marginRight: '5px',color: '#000000',fontWeight: 'bold'}}>Imp.${nFormat(parseFloat(element.taxes_amount).toFixed(outDecimals))}</span>
                                                    <span id={index} style={{fontSize: '8px',color: '#f00',fontWeight: 'bold', cursor: 'pointer'}} onClick={applyDiscount}>Des.${nFormat(parseFloat(element.discountByPrice).toFixed(outDecimals))}</span>
                                                    <span style={{fontSize: '8px',color: '#000000',fontWeight: 'bold',marginLeft: '5px',textTransform: 'uppercase'}}>{element.unit_des}</span><br />
                                                    {
                                                        !element.tableInformation?
                                                            <button className='btn btn-link btn-sm btn-custom-link' onClick={()=>addNoteToItem(element.product_id, element.condition_id, element.unit_id)}>
                                                                <FontAwesomeIcon 
                                                                    icon={element.item_note!==undefined&&element.item_note!==null&&element.item_note.length>0?faComment:faNoteSticky}                                                             
                                                                    style={{fontSize: 18, cursor: 'pointer'}}                                                            
                                                                /> Notas
                                                            </button>
                                                        :null
                                                    }
                                                    {
                                                        element.tableInformation?
                                                            <button className='btn btn-link btn-sm btn-custom-link' style={{marginLeft: 20}} onClick={()=>
                                                                {
                                                                    addFitting(element)
                                                                    // selectCurrentAdditional(element)                                                                
                                                                    // setCurrentProductSelected({
                                                                    //     ...currentProductSelected,
                                                                    //     product_id: Number(element.product_id),
                                                                    //     condition_id: Number(element.condition_id),
                                                                    //     unit_id: Number(element.unit_id)
                                                                    // })
                                                                    // setModalFittingsData(element.tableInformation)
                                                                    // setShowFittingsModal(true)
                                                                    // setFnComment(element.item_note)
                                                                }
                                                            }>
                                                                <FontAwesomeIcon 
                                                                    icon={faCutlery}
                                                                    style={{fontSize: 18, cursor: 'pointer'}}                                                                     
                                                                /> Adicionales
                                                            </button>
                                                        :null
                                                    }
                                                    
                                                </td>
                                                <td style={{width: '35%', paddingLeft: '5%'}} className='top-padding-5p'>
                                                    <div className="input-group" style={{marginTop: 5}}>
                                                        {
                                                            accessAllow?
                                                                <span 
                                                                    idx={index} 
                                                                    dataproductid={element.product_id}
                                                                    dataunitid={element.unit_id}
                                                                    dataconditionid={element.condition_id}
                                                                    className="input-group-text btn text-danger zIndex" 
                                                                    onClick={removeItemFromShoppingCart} 
                                                                    style={{paddingTop: 0,paddingBottom: 0,paddingRight: 10,paddingLeft: 5,fontSize: 22}}
                                                                >
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </span>
                                                            :null
                                                        }  

                                                        {/* <input 
                                                            id={index}
                                                            type="number" 
                                                            className="form-control" 
                                                            value={prdQty} 
                                                            readOnly={true} 
                                                            style={{                                                                
                                                                paddingTop: 0,
                                                                paddingBottom: 0,
                                                                paddingRight: 5,
                                                                paddingLeft: 5,
                                                                textAlign: 'center',
                                                                cursor: 'pointer',
                                                                display: 'none'
                                                            }}
                                                            title="Selecciona para agregar mas productos"
                                                            onClick={addItemByNumber} /> */}

                                                        <span 
                                                            id={index}
                                                            className="input-group-text btn zIndex" 
                                                            title="Selecciona para agregar mas productos"
                                                            style={{paddingTop: 5,paddingBottom: 0,paddingRight: 5,paddingLeft: 5,fontSize: 14}}
                                                        >
                                                            {element.showQty}
                                                        </span>

                                                        <span 
                                                            id={index}
                                                            dataproductid={element.product_id}
                                                            dataunitid={element.unit_id}
                                                            dataconditionid={element.condition_id}
                                                            className="input-group-text btn text-success zIndex" 
                                                            title="Selecciona para agregar mas productos"
                                                            onClick={addItemToShopping} 
                                                            style={{paddingTop: 0,paddingBottom: 0,paddingRight: 5,paddingLeft: 10,fontSize: 22}}
                                                        >
                                                            <FontAwesomeIcon icon={faPlusCircle} />
                                                        </span>
                                                    </div>
                                                </td>
                                                <td style={{width: '20%',textAlign: 'right',fontWeight: 'bold',color: '#000000',fontSize: '12px'}} className='top-padding-10p'>
                                                    ${nFormat( parseFloat( outDecimals==0 ? Math.round( ( parseFloat(element.total_amount)*parseFloat(element.showQty) ) ).toFixed(outDecimals) : ( parseFloat(element.total_amount) * parseFloat(element.showQty) ) ).toFixed(outDecimals) )}
                                                </td>
                                            </tr>
                                        )
                                    })
                                :
                                <>
                                    <tr>
                                        <td className='text-muted' style={{fontSize: 42, border: 0, paddingTop: '30%'}}><FontAwesomeIcon icon={faListCheck} /></td>
                                    </tr>
                                    <tr>
                                        <td className='text-muted' style={{fontSize: 18, border: 0, textTransform: 'initial'}}>Productos no encontrados</td>
                                    </tr>
                                    <tr>
                                        <td className='text-sm text-muted' style={{fontSize: 14, border: 0, textTransform: 'initial'}}>Debe agregar al menos un artículo a la lista para poder realizar la venta.</td>
                                    </tr>
                                </>
                            }
                            </tbody>
                        </table>
                    </div>                    
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <table className="table table-bordered" style={{marginBottom: 0}}>
                        <tbody>
                            {
                                shoppingCartPos.map((element)=>{
                                    scAmount += parseFloat(element.total_amount);
                                    scSubTotal += (parseFloat(element.total_price)*parseFloat(element.qty));
                                    scTaxes += (parseFloat(element.taxes_amount)*parseFloat(element.qty));
                                    scDiscount += (parseFloat(element.discountByPrice)*parseFloat(element.qty));
                                })
                            }
                            <tr>
                                <td className='bg-color-td text-foot-custom' style={{fontWeight: 'bold'}}>
                                    <span className='bold'>Sub-Total:</span> <span className='text-info'>${nFormat(parseFloat(scSubTotal).toFixed(outDecimals))}</span>
                                </td>

                                <td className='bg-color-td text-foot-custom' style={{fontWeight: 'bold'}}>
                                    <span className='bold'>Impuesto:</span> <span className='text-success'>${nFormat(parseFloat(scTaxes).toFixed(outDecimals))}</span>
                                </td>

                                <td className='bg-color-td text-foot-custom' style={{fontWeight: 'bold'}}>
                                    <span className='bold'>Descuento:</span> <span className='text-danger'>${nFormat(parseFloat(scDiscount).toFixed(outDecimals))}</span>
                                </td>

                                <td className='bg-color-td text-foot-custom' style={{fontWeight: 'bold'}}>
                                    <span className='bold'>Monto:</span> <span className='text-primary'>${nFormat(outDecimals==0?Math.round(parseFloat(scAmount)).toFixed(outDecimals):parseFloat(scAmount).toFixed(outDecimals))}</span>
                                </td>
                                {
                                    !isMobile?
                                        <>
                                            <td style={{padding: 0, paddingRight: 5}}>
                                                {
                                                    !accountLoading?
                                                        <button className='btn btn-primary' style={{width: '100%',fontSize: '14px'}} onClick={createAccount}><FontAwesomeIcon icon={faReceipt} />{accountHeadId>0?" ACTUALIZAR CUENTA ":" ABRIR CUENTA "}</button>
                                                    :<Button variant="primary" disabled>
                                                        <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        />
                                                        Loading...
                                                    </Button>
                                                }
                                            </td>
                                            <td style={{padding: 0}}>
                                                <button className='btn btn-success' style={{width: '100%',fontSize: '14px'}} onClick={searchBillingUser}>
                                                    <FontAwesomeIcon icon={faMoneyBill} /> FACTURAR CUENTA
                                                </button>
                                            </td>
                                            {
                                                accountHeadId>0?
                                                    <td colSpan={2} style={{padding: 0, paddingLeft: 5}}>
                                                        <button className='btn btn-secondary' style={{width: '100%',fontSize: '14px'}} onClick={openNewAccount}><FontAwesomeIcon icon={faPlus} /> ABRIR NUEVA CUENTA</button>
                                                    </td>
                                                :null
                                            }
                                        </>
                                    :null
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {
                isMobile?
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className="table table-bordered" style={{marginBottom: 0}}>
                                <tbody>
                                    <tr>
                                        <td style={{padding: 0, paddingTop: 5, paddingRight: 5}}>
                                            {
                                                !accountLoading?
                                                    <button className='btn btn-primary' style={{width: '100%',fontSize: '14px'}} onClick={createAccount}><FontAwesomeIcon icon={faReceipt} />{accountHeadId>0?" Actualizar Cuenta ":" Abrir Cuenta "}</button>
                                                :<Button variant="primary" disabled>
                                                    <Spinner
                                                    as="span"
                                                    animation="grow"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    />
                                                    Loading...
                                                </Button>
                                            }
                                        </td>
                                        <td style={{padding: 0, paddingTop: 5}}>
                                            <button className='btn btn-success' style={{width: '100%',fontSize: '14px'}} onClick={searchBillingUser}>
                                                <FontAwesomeIcon icon={faFileInvoice} /> Facturar Cuenta
                                            </button>
                                        </td>

                                        {
                                            accountHeadId>0?
                                                <td colSpan={2} style={{padding: 0, paddingTop: 5, paddingLeft: 5}}>
                                                    <button className='btn btn-secondary' style={{width: '100%',fontSize: '14px'}} onClick={openNewAccount}><FontAwesomeIcon icon={faPlus} /> Abrir Nueva Cuenta</button>
                                                </td>
                                            :null
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                :null
            }
        </div>
        <ModalProducts 
            show={modalProducts} 
            params={modalProductsParam} 
            handle={setModalProducts} 
            handleProducts={setProducts}
            defaultCurrency={defaultCurrency}
            defaultCurrencyLabel={defaultCurrencyLabel}
            fromPos={true}
            /*editingProduct={editingProduct}*/ />
        <ModalCustomer 
            show={modalCustomer} 
            params={modalCustomersParam} 
            handle={setModalCustomer} 
            handleCustomers={setCustomerOptions}
            customerIdInput={customerIdInput}
            setCustomerNameInput={setCustomerNameInput}
            customerNameInput={customerNameInput}
            customerPhoneInput={customerPhoneInput}
            customerEmailInput={customerEmailInput}
            customerDocumentInput={customerDocumentInput}
            customerDocumentTypeInput={customerDocumentTypeInput}
            customerBpDateInput={customerBpDateInput}
            customerPaymentMethod={customerPaymentMethod}
            setCusOptionSelected={setCusOptionSelected}
            />
        <ModalPayment 
            show={modalPayments} 
            handle={setModelPayments}
            setShoppingCartPos={setShoppingCartPos} 
            handleShoppingCart={shoppingCartPos} 
            handleCustomer={cusOptionSelected} 
            setCusOptionSelected={setCusOptionSelected}
            handleNcfInfo={ncfInfo}
            accountHeadId={accountHeadId}
            defineCurrencyId={defaultCurrency}
            defineCurrencyRef={defaultCurrencyLabel}
            billingUser={billingUser}
            outDecimals={outDecimals}
            paymentConditions={paymentConditions}
            identifierPreSelection={identifierPreSelection}
            execFe={execFe}
            customerOptions={customerOptions}
            setCustomerOptions={setCustomerOptions}
            modalBdParams={modalBdParams}
            autoMarkLawPercent={autoMarkLawPercent}
            guessChangeCustomer={guessChangeCustomer}
            openCustomerModal={openCustomerModal}
            openCustomerModalForUpdate={openCustomerModalForUpdate}
            useFe={useFe}
            exentoTaxes={exentoTaxes}
            />
        <ModalBb 
            show={modalBb}
            handle={setModalBb}
            datax={modalBdParams}
            bbOpen={setCheckBb}
            setModalBbRemoveNote={setModalBbRemoveNote}
            modalBbRemoveNote={modalBbRemoveNote}
            />
        <ModalAccess 
            show={accessShow}
            handle={setAccessShow}
            setAccessAllow={setAccessAllow}
        />
        <ModalMultiPrice 
            show={showMultiPrice}
            handle={setShowMultiPrice}
            product={productSelectedToMulti}
            setProduct={setProductSelectedToMulti}
            list={pricingList}
            shoppingCartPos={shoppingCartPos}
            setShoppingCartPos={setShoppingCartPos}
        />
        <ModalArea 
            visible={visible}
            setVisible={setVisible}
            accounts={accountTables}
            setTableAccount={setTableAccount}
            setTableAccountDescription={setTableAccountDescription}
            setOpenAccountRegistered={setOpenAccountRegistered}
            setItemAccounts={setItemAccounts}
            setShowModalItemAccount={setShowModalItemAccount}
        />
        <ModalAccount 
            accounts={itemAccounts}
            visible={showModalItemAccount}
            setVisible={setShowModalItemAccount}
        />
        <ModalFittings
            show={showFittingsModal}
            onHide={() => setShowFittingsModal(false)}
            data={modalFittingsData}
            onSave={handleSave}
            fittingData={currentFittingData}
            fnCommentValue={fnComment}
            fnComment={setFnComment}
        />
        <ModalComanda
            comandas={comandas}
            visible={showComanda}
            setVisible={setShowComanda}
            accountComandaSelected={accountComandaSelected}
            setAccountComandaSelected={setAccountComandaSelected}
            setComandas={setComandas}
            printPermission={posPermissions.printPermission}
        />
        <ModalPendingAccount 
            accounts={pendingAccountList}
            visible={pendingModalAccount}
            setVisible={setPendingModalAccount}
        />
        </>
    )
}
export default Pos;